import React, { useState, useEffect } from "react";
import ClientHeader from "../../../common/ClientHeader";
import ProtectedPage from "../../../common/ProtectedPage";
import "./ShopPageStyles.css";
import { ProductsQueriesClient } from "../../../../requests/queries/ProductsQueries";
import LoadingSpinner from "../../../common/Loading";
import { Link } from "react-router-dom";
import Sidebar from "../../../common/Sidebar";

const ShopPage = ({ currentCommand, setCurrentCommand }) => {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    
    const category = window.location.search.split('=')[1] ?? "all";

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 800);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const fetchProducts = async () => {
        if(!category || category === "all") {
            const res = await ProductsQueriesClient.findAll();
            setProducts(res.data.products);
        }
    }

    const fetchProductsByCategoriesFilter = async () => {
        if(category && category !== "all") {
            const res = await ProductsQueriesClient.findByCategoriesFilter([category]);
            setProducts(res.data.products);
        }
    }

    const fetchProductsBySearch = async () => {
        if(debouncedSearchTerm) {
            const res = await ProductsQueriesClient.findBySearchWithDetails(debouncedSearchTerm);
            setProducts(res.data.products);
        } else {
            const res = await ProductsQueriesClient.findAll();
            setProducts(res.data.products);
        }
    }

    useEffect(() => {
        setTimeout(() => {
            fetchProducts();
            setIsLoading(false);
        }, 1200);
    }, []);

    useEffect(() => {
        if (debouncedSearchTerm) {
            fetchProductsBySearch();
        } else if (category === "all") {
            fetchProducts();
        } else {
            fetchProductsByCategoriesFilter();
        }
    }, [debouncedSearchTerm, category]);

    if (isLoading) {
        return (
            <ProtectedPage key={`shop-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={true} redirectPath="/client-secret" currentCommand={currentCommand} setCurrentCommand={setCurrentCommand}>
                <div className="patricians-layout">
                    <ClientHeader currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                    <div className="patricians-main-content">
                        <LoadingSpinner style={{height: '100vh', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000}} />
                    </div>
                </div>
            </ProtectedPage>
        );
    }

    return (
        <ProtectedPage key={`shop-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={true} redirectPath="/client-secret" currentCommand={currentCommand} setCurrentCommand={setCurrentCommand}>
            <div className="patricians-layout">
                <ClientHeader 
                    currentCommand={currentCommand} 
                    setCurrentCommand={setCurrentCommand}
                    onSearchChange={setSearchTerm}
                />
                <div className="patricians-main-content">
                    {/* Sidebar gauche avec catégories */}
                    <Sidebar />

                    {/* Zone principale avec produits */}
                    <main className="patricians-products-area">
                        {products.length > 0 ? (
                            <div className="patricians-products-grid">
                                {products.map(product => product.default_price_id && (
                                    <Link 
                                        key={product.id} 
                                        to={`/shop/product/${product.id}`}
                                        className="patricians-product-card"
                                    >
                                        <div className="patricians-product-image">
                                            <img 
                                                src={product.images.find(image => image.id === product.default_image_id)?.image_url || product.images[0]?.image_url} 
                                                alt={product.name}
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/400x400?text=Image';
                                                }}
                                            />
                                        </div>
                                        <div className="patricians-product-info">
                                            <h3 className="patricians-product-name">{product.name}</h3>
                                            <p className="patricians-product-price">
                                                €{(() => {
                                                    const price = product.prices.find(price => price.id === product.default_price_id)?.price;
                                                    if (price) {
                                                        const numPrice = typeof price === 'string' ? parseFloat(price) : price;
                                                        return isNaN(numPrice) ? '0,00' : numPrice.toFixed(2).replace('.', ',');
                                                    }
                                                    return '0,00';
                                                })()}
                                            </p>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <div className="patricians-no-products">
                                <h3>NO PRODUCTS FOUND</h3>
                                <p>Try modifying your search criteria</p>
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </ProtectedPage>
    );
};

export default ShopPage;